export const getScoreColor = (score: number): string => {
  if (score >= 60) return "#E24B4A";
  if (score >= 40) return "#EF9F27";
  if (score >= 20) return "#97C459";
  return "#639922";
};
